import styled from "styled-components";

export const SolutionsCompWrapper = styled.div`
  .solutions_heading {
    padding-bottom: 100px;
    @media (min-width: 1200px) {
      padding-bottom: 70px;
    }
    @media (min-width: 1199px) {
      padding-bottom: 70px;
    }
    @media (max-width: 899px) {
      padding-bottom: 55px;
    }
    @media (max-width: 599px) {
      padding-bottom: 40px;
    }
    .row {
      margin: -10px;
      @media (max-width: 1199px) {
        margin: -7px;
      }
      @media (max-width: 599px) {
        margin: -3.5px;
      }
      .col {
        width: calc(100% - 53%);
        padding: 10px;
        @media (max-width: 1199px) {
          width: 100%;
          padding: 7px;
        }
        @media (max-width: 599px) {
          padding: 3.5px;
        }
        &.heading_left {
          width: 53%;
          @media (max-width: 1199px) {
            width: 100%;
          }
        }
        h2 {
          font-weight: 300;
          font-size: 64px;
          @media (max-width: 1199px) {
            font-size: 45px;
          }
          @media (max-width: 899px) {
            font-size: 35px;
          }
          @media (max-width: 599px) {
            font-size: 22px;
          }
          span {
            margin-left: 7.5px;
            font-style: italic;
            font-weight: 700;
            color: #ff1818;
          }
        }
      }
    }
  }
  .cardDivWrap {
    .row {
      margin: -38.5px -10px;
      @media (max-width: 1199px) {
        margin: -33.3px -10px;
      }
      @media (max-width: 599px) {
        margin: -25.3px -10px;
      }

      .card_div {
        width: 33.3%;
        padding: 38.5px 10px;
        @media (max-width: 1199px) {
          width: 50%;
          padding: 33.3px 10px;
        }
        @media (max-width: 599px) {
          width: 100%;
          padding: 25.3px 10px;
        }
      }
    }
  }
`;
